namespace GpScot.MessageBanner {
	export function init() : void {

		const banner = document.getElementById("messageBanner") as HTMLDivElement;

		if (!banner) {
			return;
		}

		const closeButton = banner.querySelector("#closeBtn") as HTMLButtonElement;

		closeButton.addEventListener("click", () => {
			banner.classList.add("hidden");

			setTimeout(() => {
				banner.remove();
			}, 300);
		})
	}
}